<template>
  <div class="gauge-root">
    <Progress
      :radius="18"
      :strokeWidth="10"
      strokeColor="#AFE68B"
      :value="value"
    >
      <template v-slot:footer>
        <Localization message="monthly-summary-forecast-sla" />
      </template>
    </Progress>
  </div>
</template>

<script>
import { Localization, Translator } from "@agyletime/wfm-vue-common";
import Progress from "easy-circular-progress";

export default {
  name: "ForecastGauge",
  mixins: [Translator],
  components: {
    Localization,
    Progress,
  },
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
  },
};
</script>

<style lang="scss">
.gauge-root {
  text-align: center;

  .vue-circular-progress {
    line-height: 0;

    .circle {
      margin: 0 0 3px;

      .circle__svg {
        transform: rotate(90deg) scale(-1, 1);
      }

      .circle__progress--path {
        stroke: rgb(214, 214, 214) !important;
        stroke-opacity: 0.8;
      }

      .circle__progress--fill {
        stroke-linecap: unset !important;
      }

      .percent {
        .dot,
        .percent__dec {
          display: none;
        }

        .percent__int,
        .percent_sign {
          font-size: 10px;
        }
      }
    }

    span {
      font-size: 11px;
    }
  }
}
</style>
